import { render, staticRenderFns } from "./FilterPublicProductBrands.vue?vue&type=template&id=bd0b38b2&"
import script from "./FilterPublicProductBrands.vue?vue&type=script&lang=js&"
export * from "./FilterPublicProductBrands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports